import React from "react";
import { Routes, Route } from "react-router-dom";

import Redirect from "../Redirect";
import Home from "../Home";
import Register from "../Register";
import Partner from "../Partner";
import PartnerNotifications from "../Partner/Notifications";
import Maps from "../Maps";

const Routers = () => {
  return (
    <Routes>
      <Route exact path="/" element={<Redirect />} />
      <Route exact path="*" element={<Redirect />} />
      <Route exact path="/:id" element={<Home />} />
      <Route exact path="/user/mapa" element={<Maps />} />
      <Route exact path="/user/cadastro" element={<Register />} />
      <Route exact path="/user/parceiro" element={<Partner />} />
      <Route
        exact
        path="/user/parceiro/notificacoes"
        element={<PartnerNotifications />}
      />
    </Routes>
  );
};

export default Routers;
